import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-tab-data" }
const _hoisted_2 = { class: "as-active" }

import type { IMatch } from "~src/interfaces";


const __default__ = {};

interface IProps {
  match: IMatch;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TabData',
  props: {
    match: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Dữ liệu đội bóng", -1)),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.match.home_team.name) + " vs " + _toDisplayString(_ctx.match.away_team.name), 1),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-tab-data__header" }, [
      _createElementVNode("div", null, "Đội nhà"),
      _createElementVNode("div", null, "3 trận gần nhất"),
      _createElementVNode("div", null, "Đội khách")
    ], -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "as-tab-data__content" }, [
      _createElementVNode("div", { class: "as-tab-data__content-item" }, [
        _createElementVNode("div", null, "33"),
        _createElementVNode("div", null, "Ghi bàn"),
        _createElementVNode("div", null, "44")
      ])
    ], -1))
  ]))
}
}

})